module.exports = __webpack_public_path__ + "static/img/iconmenu03.c6ee9c4a.svg";